export function noValue(text, emptyText = "(No Value)") {
    if (typeof text == 'number')
        return text.toString();
    return text == null || text == undefined || text.trim() == '' ? emptyText : text;
}
